import store from '@/store/index';
import router from '@/routes/index';
export function setInterceptors(instance) {
  // Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      config.headers.Authorization = `Bearer ${store.state.token}`;
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      const { data } = error.response;
      //console.log('interceptor error', data);
      if (data.result === 'DoesNotLogged') {
        router.push({
          name: 'login',
        });
      }
      return Promise.reject(error);
    },
  );
  return instance;
}
